<template>
  <TenderPlug
    :title="$t('No active tenders yet')"
    :description="$t('Create your first tender using the button below')"
    :action-text="$t('Create new tender')"
    :small="small"
    @action="$emit('action')"
  >
    <template #icon>
      <PaperIcon />
    </template>
  </TenderPlug>
</template>

<script>
  import PaperIcon from '@/assets/icons/paper.svg';
  import TenderPlug from '@/components/tender/TenderPlug';

  export default {
    name: 'ActiveTenderPlug',
    components: {
      PaperIcon,
      TenderPlug,
    },
    props: {
      small: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
